import { render, staticRenderFns } from "./ProcurementPurchaseRequest.vue?vue&type=template&id=4fef06e4"
import script from "./ProcurementPurchaseRequest.vue?vue&type=script&lang=js"
export * from "./ProcurementPurchaseRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports